import { ThemeTokens } from './types';

const lightThemeTokens: ThemeTokens = {
	risk_colors: {
		low: {
			500: '#17A93B',
			400: '#41BA5F',
			300: '#6CCA83',
			200: '#B7E4C2',
			100: '#E8F6EB',
			default: '#17A93B'
		},
		medium: {
			500: '#FFB40A',
			400: '#FFC33B',
			300: '#FFD26C',
			200: '#FFE8B3',
			100: '#FFF8E7',
			default: '#FFB40A'
		},
		moderate: {
			500: '#F2751C',
			400: '#F59149',
			300: '#F7AC77',
			200: '#FBD4B9',
			100: '#FEF1E8',
			default: '#F2751C'
		},
		high: {
			500: '#D13342',
			400: '#DA5C68',
			300: '#E3858E',
			200: '#F1C0C4',
			100: '#FAEBEC',
			default: '#D13342'
		},
		very_high: {
			500: '#7828C8',
			400: '#9353D3',
			300: '#AE7EDE',
			200: '#D5BCEE',
			100: '#F2EAFA',
			default: '#7828C8'
		}
	},
	primary_colors: {
		50: '#F7F8FD',
		100: '#E6EAF8',
		200: '#B0BFEA',
		250: '#BFBFBF',
		400: '#5474D1',
		500: '#002FBB',
		700: '#002185',
		800: '#00144F',
		default: '#002FBB'
	},
	secondary_colors: {
		white: '#FFFFFF',
		50: '#F8F8F8',
		100: '#F0F0F0',
		150: '#E6E6E6',
		200: '#D9D9D9',
		250: '#BFBFBF',
		300: '#8C8C8C',
		400: '#505050',
		500: '#262626',
		default: '#262626'
	},
	border_radius: {
		br_xs: '0.125rem',
		br_sm: '0.25rem',
		br_md: '0.375rem',
		br_lg: '0.5rem',
		br_xl: '0.625rem'
	},
	font_weights: {
		regular: 400,
		semibold: 600
	},
	line_heights: {
		lh_xs: '0.75rem',
		lh_sm: '1rem',
		lh_md: '1.125rem',
		lh_lg: '1.25rem',
		lh_xl: '1.375rem',
		lh_2xl: '1.5rem',
		lh_3xl: '2rem',
		lh_4xl: '2.25rem',
		lh_5xl: '2.5rem',
		lh_6xl: '3rem',
		lh_7xl: '3.5rem',
		lh_8xl: '4.5rem'
	},
	letter_spacings: {
		ls_2xs: '-0.015rem',
		ls_xs: '-0.035rem',
		ls_sm: '-0.03rem',
		ls_md: '-0.0195rem',
		ls_lg: '-0.01525rem',
		ls_xl: '-0.00781rem',
		ls_2xl: '-0.00625rem',
		ls_3xl: '-0.00563rem',
		ls_4xl: '-0.005rem',
		ls_5xl: '-0.00438rem',
		ls_6xl: '0.00281rem',
		ls_7xl: '0.01219rem',
		ls_8xl: '0.015rem',
		ls_9xl: '0.01563rem'
	},
	font_sizes: {
		fs_3xs: '0.5rem',
		fs_2xs: '0.625rem',
		fs_xs: '0.75rem',
		fs_sm: '0.875rem',
		fs_md: '1rem',
		fs_lg: '1.125rem',
		fs_xl: '1.25rem',
		fs_2xl: '1.5rem',
		fs_3xl: '1.5625rem',
		fs_4xl: '1.75rem',
		fs_5xl: '1.95313rem',
		fs_6xl: '2.44144rem',
		fs_7xl: '3.05156rem'
	},
	font_family: {
		primary: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"
	}
};

export default lightThemeTokens;
